module.exports = __webpack_public_path__ + "assets/plus_new.bbbc7324abb1be3f279adc07b3098b57.svg";